import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import useAuthService from '../app/services/hooks/useAuthService';

/**
 * Vuelve a leer la sesión del backend (roles, permisos, estudio, plan y marca)
 * sin pedir login otra vez. Se usa después de cambiar plan, marca o rol para
 * que el menú, los límites y los colores se actualicen al tiro.
 */
const useRefreshAuth = () => {
    const { auth, updateAuth } = useContext(AuthContext);
    const { validateTokenAuth } = useAuthService();

    const refreshAuth = () => {
        validateTokenAuth({
            onSuccess: (response) => {
                if (!auth || !updateAuth) return;
                updateAuth({
                    ...auth,
                    roles: response.data.roles,
                    permissions: response.data.permissions,
                    hasAllPermissions: response.data.hasAllPermissions,
                    organization: response.data.organization ?? null,
                    branding: response.data.branding ?? null
                });
            }
        });
    };

    return { refreshAuth };
};

export default useRefreshAuth;
